import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from "Constants/BIDashboardConstants"
const CheckCircleIcon = ({ name }) => {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" id={name}>
      <title>Check Circle Icon.</title>
      <defs />
      <g id="Registration" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Registration---Product-Selection---Pro-Selected---Final" transform="translate(-606.000000, -702.000000)">
          <g id="Product-Upgrade---Step-2" transform="translate(285.000000, 246.000000)">
            <g id="2-column-table" transform="translate(0.000000, 19.000000)">
              <g id="Pro-Plan" transform="translate(264.000000, 81.000000)">
                <g id="Upgrade-to-Pro-w/-Check" transform="translate(26.000000, 342.000000)">
                  <g id="Group" transform="translate(31.000000, 14.000000)">
                    <circle id={name} fill="#FFFFFF" cx="8" cy="8" r="8" />
                    <path
                      d="M6.03508772,10.3684211 L12,5 L6.03508772,10.3684211 L4,8.33333333 L6.03508772,10.3684211 Z M6.03508772,10.3684211 L5.33333333,11 L6.03508772,10.3684211 L6.66666667,11 L6.03508772,10.3684211 Z"
                      id={name}
                      stroke={COLORS.oneGp.globalBlue}
                      strokeWidth="2"
                      strokeLinecap="square"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

CheckCircleIcon.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

CheckCircleIcon.defaultProps = {
  name: 0,
};


export default CheckCircleIcon;
